import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Button,
  DialogActions,
  TextField
} from "@material-ui/core";
import * as React from "react";
import { colors } from "../constants/constants";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary
    },
    control: {
      padding: theme.spacing(1) * 2
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth
      }
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none"
      }
    },
    margin: {
      margin: theme.spacing(1)
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible"
      },
      color: "black"
    },
    extendedIcon: {
      marginRight: theme.spacing(1)
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex"
      }
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff"
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64
    },
    nested: {
      paddingLeft: theme.spacing(4)
    },
    drawerPaper: {
      width: drawerWidth
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3)
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15)
    }
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  questionItem: any;
  dialogTitle: any;
  onClose: any;
  onSave: any;
}
class AddInputDialog extends React.Component<Props> {
  state = {
    value: ""
  };
  handleClose = () => {
    this.props.onClose();
  };
  componentDidMount = () => {
    if (this.props.questionItem && this.props.questionItem.value) {
      this.setState({
        value: this.props.questionItem.value.notes
      });
    }
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps.questionItem.value !== this.props.questionItem.value) {
      this.setState({
        value: this.props.questionItem.value.notes
      });
    }
  };

  render() {
    const { open, dialogTitle, onClose, onSave } = this.props;
    return (
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={open}
          onClose={onClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">{dialogTitle}</DialogTitle>
          <Divider />
          <DialogContent>
            <TextField
              fullWidth
              id="standard-multiline-static"
              label="Add notes"
              value={this.state.value}
              onChange={event => {
                this.setState({
                  value: event.target.value
                });
              }}
              multiline
              rows={10}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={() => onSave(this.state.value)}>Save</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddInputDialog);
